import React from 'react';
import { PropTypes } from 'prop-types';

const FieldContainer = ({ label, className, children, ...props}) => {
  return (
    <fieldset>
      <label className="title">{label}</label>
      <div className={className} {...props}>
        {children}
      </div>
    </fieldset>
  );
}

FieldContainer.defaultProps = {
  className: "right"
};

FieldContainer.propTypes = {
  label: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node
}

export default FieldContainer;



// WEBPACK FOOTER //
// ./src/components/form/FieldContainer.js